'use client'
import { getWalletColor, hexToRgba } from '@polaris/core/utils'
import { ClientOnly } from '@quirks/react'
import Image from 'next/image'
import { PRIVACY_UI } from '@/src/stores/privacy/constants'

/**
 * Displays the Polaris logo with a colored background for Privacy Vault accounts
 */
export const PrivacyAccountLogo = () => {
  const walletColor = getWalletColor('Polaris', 'MPCVault')
  const backgroundColor = hexToRgba(walletColor, 0.6)

  return (
    <ClientOnly>
      <div
        className='rounded-[6px] flex items-center justify-center shrink-0'
        style={{ width: 24, height: 24, backgroundColor }}
      >
        <Image
          alt='Polaris'
          src={PRIVACY_UI.POLARIS_LOGO}
          width={18}
          height={18}
          unoptimized
        />
      </div>
    </ClientOnly>
  )
}
